import React from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Button } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";
import { MiniPlus } from "../../assets";
import { toast } from "react-toastify";
import { ModalTemplate, ModalFields } from "../UI/modalComponents";
import { formTypes } from "../UI/form";
import BaseModal from "./baseModal/BaseModal";
import {
  STRING_INPUT,
  TITLE,
  TEXT_AREA,
  GET_HTML,
  IMAGE_DROPDOWN,
  SWITCH,
  DROPDOWN,
  DATE_PICKER,
  SELECT_MULTIPLE_DROPDOWN
} from "./baseModal/FieldTypes";
import { notEmptyString, validateEmail } from "./baseModal/validators";
import { BLUE_BUTTON, RED_BUTTON, WHITE } from "./baseModal/colours";

const recommendedDocs = 
  {
  "credit_not_processed": [
    "Cancellation Policy",
    "Refund Policy",
    "Cancellation Policy Disclosure",
    "Refund Policy Disclosure",
    "Customer Communication"
  ],
  "customer_initiated": [
    "Any relevant communication with the customer regarding the transaction.",
    "Documentation showing the product or service was provided as described.",
    "Proof that the customer agreed to your terms of service and refund policy."
  ],
  "debit_not_authorized": [
    "Proof of customer authorization, such as AVS and CVC confirmations.",
    "Correspondence with the customer confirming the purchase.",
    "Evidence of prior non-fraudulent transactions with the same customer."
  ],
  "duplicate": [
    "Duplicate Charge Id",
    "Duplicate Charge Explanation",
    "Duplicate Charge Documentation",
    "Customer Communication",
  ],
  "fraudulent": [
    "Proof of customer authorization, such as AVS and CVC confirmations.",
    "IP address and system logs showing the customer accessed or downloaded the digital product.",
    "Correspondence with the customer confirming the purchase.",
    "Evidence of prior non-fraudulent transactions with the same customer."
  ],
  "general": [
    "Any relevant communication with the customer regarding the transaction.",
    "Documentation showing the product or service was provided as described.",
    "Proof that the customer agreed to your terms of service and refund policy."
  ],
  "incorrect_account_details": [
    "Records showing the account details provided by the customer during the transaction.",
    "Correspondence with the customer confirming the account details."
  ],
  "insufficient_funds": [
    "Evidence that the transaction was declined due to insufficient funds.",
    "Correspondence with the customer regarding the failed payment and any attempts to resolve it."
  ],
  "product_not_received": [
    "System logs or records demonstrating the customer accessed, downloaded, or used the digital product.",
    "Correspondence with the customer confirming receipt or access to the product.",
    "Proof that the customer created an account and logged in to use the service."
  ],
  "product_unacceptable": [
    "Evidence that the digital product was as described, such as product descriptions or advertisements.",
    "Correspondence with the customer addressing their concerns about the product.",
    "System logs showing the customer used or accessed the product after purchase."
  ],
  "subscription_canceled": [
    "Records showing the subscription was canceled according to your policy.",
    "Proof that the customer was informed of the subscription terms and cancellation policy.",
    "Correspondence with the customer regarding the subscription and its cancellation."
  ],
  "unrecognized": [
    "Proof of customer authorization, such as AVS and CVC confirmations.",
    "IP address and system logs showing the customer accessed or downloaded the digital product.",
    "Correspondence with the customer confirming the purchase."
  ]
}

const textFileTypes = {
  text: [
    "access_activity_log", "billing_address", "cancellation_policy_disclosure", "cancellation_rebuttal",
    "customer_email_address", "customer_name", "customer_purchase_ip", "duplicate_charge_explanation", 
    "duplicate_charge_id", "product_description", "refund_policy_disclosure", "refund_refusal_explanation",
    "service_date", "uncategorized_text"
  ]
}


class DisputeEvidenceModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      text: "",
      category: "",
      stripeFileId: ""
    };
  }

  fetchInitialData = async () => {
    return;
  };
  componentDidMount() {
    this.fetchInitialData();
  }
  async fileChangeDoc(e) {
    if (e.target.files.length && e.target.files[0]) {
      const fd = new FormData();
      fd.set("doc", e.target.files[0]);
      const ep = `${process.env.REACT_APP_API}/partners/stripe/dispute/document`;
      this.setGlobal({ loading: true });
      const result = await axios.post(ep, fd );
      this.setGlobal({ loading: false });
      if (result.data.success) {
        this.setState({ file: result.data.data, text: "" });
      } else {
        toast.error("File did not meet the specified requirements");
      }
    }
  }

  fileAttachContent = () => {
    return (
      <div
        className="form-group"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 0
        }}
      >
        {this.state.file ? (
          <h4
            style={{
              margin: 0,
              fontSize: "15px",
              color: "black",
              fontFamily: "futura-pt, sans-serif",
              fontWeight: "500",
              color: "#626262"
            }}
          >
            File Uploded !
          </h4>
        ) : (
          <>
            <div style={{ width: "35%" }}>
              <p
                style={{
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                  fontFamily: "futura-pt, sans-serif",
                  fontWeight: "700",
                  color: "#626262",
                  marginBottom: 0
                }}
              >
                Upload Document <br />
                <span
                  style={{
                    fontSize: "9px",
                    fontFamily: "futura-pt, sans-serif"
                  }}
                >
                  (max. 5mb)
                </span>
              </p>
              <Button
                variant="contained"
                color="primary"
                component="span"
                style={{ fontFamily: "futura-pt, sans-serif" }}
                startIcon={<CloudUpload />}
                fullWidth
                onClick={_ => {
                  document.getElementById("uploadDocument").click();
                }}
              >
                Document
              </Button>
            </div>
            <span
              style={{
                width: "10%",
                fontSize: "14px",
                textAlign: "center",
                marginTop: "15px",
                fontFamily: "futura-pt, sans-serif",
                color: "#626262"
              }}
            >
              OR
            </span>
            <div style={{ width: "50%" }}>
              <p
                style={{
                  fontSize: "0.7rem",
                  marginBottom: 0,
                  fontFamily: "futura-pt, sans-serif",
                  color: "#626262",
                  fontWeight: 700
                }}
              >
                Paste Text
              </p>
              <input
                name="text"
                id="displayName"
                type="text"
                className="form-control"
                placeholder=""
                style={{ width: "100%" }}
                onChange={e => {
                  this.setState({
                    [e.target.name]: e.target.value
                  });
                }}
                pattern=""
                title=""
              />
            </div>
          </>
        )}
        <input
          type="file"
          style={{ display: "none" }}
          id="uploadDocument"
          onChange={e => this.fileChangeDoc(e)}
          accept="image/png,application/pdf,image/jpeg"
        />
      </div>
    );
  };

  getCategories = () => {
    let categories = [];
    if (this.props.dispute && this.props.dispute.evidence) {
      Object.keys(this.props.dispute.evidence).forEach(key => {
        // Transform the key into the desired format
        const text = key
          .split("_") // Split the key by underscores
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
          .join(" "); // Join the words with spaces

        categories.push({ value: key, text: text });
      });
    }
    categories = categories.filter(cat => {
      let inText = textFileTypes.text.includes(cat.value);
      //console.log("category", cat.value, inText);
      if (this.state.text !== "" && inText) {
        return true;
      } else if (this.state.file !== null && !inText) {
        return true;
      }
      return false;
    })
    console.log("categories", categories);
    return categories;
  };

  onSubmit = async () => {
    console.log("state", this.state);
    const ep = `${process.env.REACT_APP_API}/partners/stripe/dispute/evidence`;
    this.setGlobal({ loading: true });
    const result = await axios.post(ep, {
      disputeId: this.props.dispute.id,
      evidence: (this.state.file ? this.state.file.stripeFileId : this.state.text),
      category: this.state.category,
    });
    this.setGlobal({ loading: false });
    if (result.data.success) {
      toast.success("Evidence submitted successfully");
      this.props.onClose();
    } else {
      toast.error("Evidence submission failed");
    }
  };
  refund = async () => {
    const ep = `${process.env.REACT_APP_API}/partners/stripe/dispute/refund`;
    this.setGlobal({ loading: true });
    const result = await axios.post(ep, { disputeId: this.props.dispute.id });
    this.setGlobal({ loading: false });
    if (result.data.success) {
      toast.success("Refunded customer");
      this.setState({});
      this.props.onClose();
    } else {
      toast.error("Refund failed");
    }
  };

  getBaseModalFields = () => {
    const reason = {
      type: TITLE,
      data: {
        name: "Reason: " + this.props.dispute.reason,
      }
    }
    let evidenceStr = "";
    for (const [key, value] of Object.entries(this.props.dispute.evidence)) {
      if (value !== null && key !== "enhanced_evidence") {
        const text = key
        .split("_") // Split the key by underscores
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(" "); // Join the words with spaces
        evidenceStr += text + ", ";
      }
    }

    const submitted = {
      type: TITLE,
      data: {
        name: "Evidence Submitted: " + evidenceStr,
      } 
    };
    const uploadAttach = {
      type: GET_HTML,
      data: {
        gethtml: this.fileAttachContent
      },
      validators: { validateSubmit: () => { return ((this.state.text === ""  && this.state.file !== null)  || 
        (this.state.file === null && this.state.text !== "")) }
      } 
    };
    const category = {
      type: DROPDOWN,
      data: {
        name: "Type of Document",
        required: true,
        placeholder: "Select Category",
        choices: [...this.getCategories()],
        handleChange: e => {
          this.setState({
            category: e.target.value
          });
        }
      },
      validators: { validateSubmit: () => { return this.state.category !== "" } }
    }
    let fields = [];
    fields.push(reason);
    fields.push(submitted);
    fields.push(uploadAttach);
    
    if (this.state.file !== null || this.state.text !== "") {
      fields.push(category);
    }
    return fields;
  };

  getBaseModalButtons = () => {
    const submitButton = {
      name: "Submit",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatorKey: "validateSubmit",
      handleClick: e => this.onSubmit(e)
    };
    const refundButton = {
      name: "Refund Customer",
      buttonColour: RED_BUTTON,
      textColour: WHITE,
      handleClick: e => { this.refund() }
    }

    return [refundButton, submitButton];
  };

  getBaseModalProps = () => {
    return {
      title: "Submit Evidence",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: this.props.onClose
    };
  };

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default withRouter(DisputeEvidenceModal);
